/**
 * https://mui.com/material-ui/customization/default-theme/?expand-path=$.shape
 */
const shape = {
  borderRadius: 0,
};

export default shape;
